import { CONSTANTS_GENERATION__value_range as CONSTANTS } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { FIELD_PRIMITIVE__bool } from '@shared/dto/generation/graph_invoke/_fields/_primitives/FIELD_PRIMITIVE__bool';
import { FIELD_PRIMITIVE__int } from '@shared/dto/generation/graph_invoke/_fields/_primitives/number/FIELD_PRIMITIVE__int';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { MAP__fields_by_role } from '@shared/types/types';
import { FIELD__tensor_latents } from '../../../_fields/_tensor/FIELD__tensor_latents';
import { ENUM__image_asset_category } from '../../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../../_fields/image/FIELD__image_asset';
import { FIELD__ml_asset_vae } from '../../../_fields/ml_asset/FIELD__ml_asset_vae';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { ENUM__field_role } from '../../_base/ENUM__field_role';
import { ENUM__invocation_type } from '../../_base/ENUM__invocation_type';
import { INVOCATION_GRID2D__view } from '../../grid2d/INVOCATION_GRID2D__view';
import { INVOCATION_SD__denoise_latents_pipeline } from '../denoise/INVOCATION_SD__denoise_latents_pipeline';
import { INVOCATION_SD__base } from '../INVOCATION_SD__base';

export class INVOCATION_SD__latents_to_image extends INVOCATION_SD__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static: string = ENUM__dto_class_name.INVOCATION_SD__LATENTS_TO_IMAGE;

  /*
   * INPUTS
   */
  //todo: use hash of input instead of uuid
  @FIELD__tensor_latents.init_as_input({})
  latents!: FIELD__tensor_latents;

  @FIELD__ml_asset_vae.init_as_input()
  vae!: FIELD__ml_asset_vae;

  @FIELD_PRIMITIVE__bool.init_as_input({ value: false })
  tiled!: FIELD_PRIMITIVE__bool;

  @FIELD_PRIMITIVE__int.init_as_input({
    value: CONSTANTS.IMAGE_SIZE_IN.min,
    multiple_of: 8,
    value_range: CONSTANTS.IMAGE_SIZE_IN,
    values_allowed: CONSTANTS.IMAGE_SIZE_IN,
  })
  tile_size!: FIELD_PRIMITIVE__int;

  /*
   * OUTPUTS
   */

  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.IMAGE })
  out!: FIELD__image_asset;

  /*
   * EVENTS
   */
  edges__try_autocreate(graph: DTO_GRAPH__instance) {
    super.edges__try_autocreate(graph);

    /*
     * INVOCATION_SD__latents_to_image -> INVOCATION_IMAGE__save
     */

    this.edges__try_autocreate_from_left_to_right_one_field(graph, INVOCATION_GRID2D__view, ['image'], this.out);

    /*
     *  INVOCATION_SD__denoise_latents_pipeline -> INVOCATION_SD__latents_to_image
     */

    this.edges__try_autocreate_from_left_to_right_one_field(graph, INVOCATION_SD__denoise_latents_pipeline, ['out__latents'], this.latents);
  }

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.SD__LATENTS_TO_IMAGE);
  }

  update_fields_aliases(fields_by_role: MAP__fields_by_role) {
    super.update_fields_aliases(fields_by_role);

    if (this.vae.model.meta.field_role == ENUM__field_role.UNKNOWN) {
      this.vae.model.try_set_field_role(fields_by_role, this.vae.model, ENUM__field_role.MODEL__VAE_DECODER);
    }
  }
}
